<template>
  <div role="tablist" aria-orientation="horizontal" class="gk-tablist">
    <button 
      v-for="(option, index) in options"
      :key="'tabindex-' + index"
      :class="{ selected: (option.value === value) }"
      @click="updateValue(option.value)"
    >
      <span v-html="option.content" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'GekkoTablist',
  props: {
    value: {
      type: Number,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .gk-tablist {
    padding: 0.25rem;
    display: flex;
    border-radius: $radiusLg;
    background: #31987d;
    // flex: 1;
    >:not([hidden])~:not([hidden]) { margin-left: 0.25rem; flex: 1; }
    button {
      border: none;
      border-radius: .5rem;
      background: transparent;
      color: #333;
      padding: 0.35rem 1rem;
      // flex: 1;
      transition: all 0.2s ease-in-out;
      white-space: nowrap;
      @media(max-width: '576px') {
        padding: 0.35rem 0.75rem;
        font-size: 14px;
      }
      font-size: 16px;
      &:not(.selected) {
        color: white;
        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
      &.selected {
        background: white;
        color: $colorBrand;
      }
    }
  }
</style>
<style lang="scss">
  .gk-tablist {
    button {
      .yearly-offer {
        color: $colorBrandHighlight;
        font-family: DINNextLTPro-Medium, sans-serif;
      }
      &.selected {
        .yearly-offer {
          color: $colorBrand800;
        }
      }
    }
    
  }
</style>